import { Nullable } from 'shared/types';
import { HistoryLog } from 'shared/listingDetail/listingHistory/types';

export const SET_LISTING_HISTORY_DATA = 'SET_LISTING_HISTORY_DATA';
export const SET_LISTING_HISTORY_LOADING = 'SET_LISTING_HISTORY_LOADING';
export const SET_LISTING_HISTORY_ERROR = 'SET_LISTING_HISTORY_ERROR';

export interface ListingHistoryState {
  loading: boolean;
  data: HistoryLog[];
  error: Nullable<string>;
}

interface FetchListingHistory {
  type: typeof SET_LISTING_HISTORY_DATA;
  data: HistoryLog[];
}

interface SetListingHistoryLoading {
  type: typeof SET_LISTING_HISTORY_LOADING;
  loading: boolean;
}

interface SetListingHistoryError {
  type: typeof SET_LISTING_HISTORY_ERROR;
  error: string;
}

export type ListingHistoryActionTypes =
  | FetchListingHistory
  | SetListingHistoryLoading
  | SetListingHistoryError;
